export const EVENTS = {
  DISH: {
    SHOW_DISH_DETAIL: 'dish.SHOW_DISH_DETAIL',
    DISH_DETAILS_REQUESTED: 'dish.DETAILS_REQUESTED',
    DISH_DETAIL_LOADING: 'dish.DETAIL_LOADING',
    DISH_DETAIL_LOADED: 'dish.DETAIL_LOADED',
    DISH_DETAIL_ERROR: 'dish.DETAIL_ERROR',
  }
};

export const ENDPOINTS = {
  DISHES: {
    DETAIL: 'https://api.monrapidoo.com/rapidoo-aggregation/products-with-sides/{id}?group=ultraxeno',
  }
};
